<template>
  <div class="center">
    <h1>404</h1>
    <p>Oops! Something is wrong.</p>
    <a class="button cursor-pointer" @click="goBack()">
      <span class="mdi mdi-24px mdi-home"></span> Go back in initial page, is
      better.</a
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn"
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  mounted() {
    if (!this.isLoggedIn) {
      localStorage.clear();
      this.$router.replace("/");
    }
  }
};
</script>

<style scoped>
.center {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.button {
  background: var(--grad-accent);
  font-weight: 500;
  color: #fff;
  font-size: var(--fs-sm);
  text-decoration: none;
  border: none;
  padding: 0.6em 1.4em;
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm), inset 0 1px 0 rgba(255, 255, 255, 0.14);
  margin-top: 2rem;
  transition: filter var(--dur) var(--ease);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.button:hover {
  background: var(--grad-accent-hover);
}

p {
  font-size: var(--fs-h2);
  text-align: center;
  font-weight: 400;
  color: var(--muted);
  margin: 0;
}

h1 {
  text-align: center;
  font-size: 7rem;
  font-weight: 600;
  color: var(--ink-900);
  letter-spacing: var(--tracking-tight);
  line-height: 1;
  margin: 0 0 8px;
}
</style>
